import { FormattedMessage, useIntl } from "react-intl";
import { Select, SelectContainer } from "../../styles";
import { useDispatch } from "react-redux";

const { Option } = Select;

export default function SelectFilter({
  value,
  setValue,
  label,
  options,
  handleReset,
  disabled = false,
  fit = false,
  hasAllOption = false,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    if (handleReset) {
      handleReset();
    }
    setValue(newValue);
  };

  const labelIntl = intl.formatMessage({
    id: label,
  });
  const noOptions = intl.formatMessage({
    id: "noOptions",
  });

  return (
    <SelectContainer fit={fit}>
      <span>{labelIntl}:</span>

      <Select
        showSearch
        value={value}
        onChange={handleChange}
        disabled={disabled}
        defaultValue={""}
        optionFilterProp="children"
        placeholder="Select a person"
        notFoundContent={<div>{noOptions}</div>}
      >
        {!value && !hasAllOption && (
          <Option value={""}>
            <FormattedMessage id="select" />
          </Option>
        )}
        {hasAllOption && (
          <Option value="">
            {intl.formatMessage({
              id: "all",
            })}
          </Option>
        )}
        {options.map((opt, i) => (
          <Option value={opt.value} key={i}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </SelectContainer>
  );
}
